<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <ion-title>Prijava</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="login-logo">
    <img src="/assets/icons/icon-512.png" alt="Kordia Logo" />
  </div>

  <div class="login-form">
    <form #loginForm="ngForm" novalidate>
      <ion-input
        label="E-mail"
        labelPlacement="stacked"
        fill="solid"
        [(ngModel)]="login.email"
        name="email"
        type="email"
        #email="ngModel"
        spellcheck="false"
        autocapitalize="off"
        errorText="Obavezno unesite e-mail"
        required
      >
      </ion-input>

      <ion-input
        label="Lozinka"
        labelPlacement="stacked"
        fill="solid"
        [(ngModel)]="login.password"
        name="password"
        type="password"
        #password="ngModel"
        errorText="Obavezno unesite lozinku"
        required
      >
      </ion-input>

      <ion-row>
        <ion-col>
          <ion-button (click)="onLogin(loginForm)" type="submit" expand="block" [disabled]="isSubmitting()">
            @if (isSubmitting()) {
              <ion-spinner name="crescent" />
            } @else {
              Prijava
            }
            </ion-button>
        </ion-col>
        <ion-col>
          <ion-button (click)="onForgotPassword()" color="light" expand="block"
            >Zaboravljena lozinka?</ion-button>
        </ion-col>
      </ion-row>
    </form>
  </div>
</ion-content>
